/* unplugin-vue-components disabled */import { render } from "./PrivacyPolicy.vue?vue&type=template&id=5f0030a6&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=5f0030a6&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0030a6"]])

export default __exports__